/*
 * Иконки лендинга: outline, тонкие, одного веса — как требует ТЗ.
 *
 * Значки способов установки рисуем сами, а не берём картинками магазинов:
 * пустая рамка-плейсхолдер рядом с пунктом читается как невыбранный чекбокс,
 * а логотип магазина, где приложения нет, — как обещание.
 */

const svg = (children, props = {}) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
    {children}
  </svg>
);

export function Icon({ name, className = '' }) {
  const p = { className: `ic ${className}` };
  switch (name) {
    case 'apple':
      return svg(
        <>
          <path d="M16.2 12.5c0-2 1.6-3 1.7-3-.9-1.4-2.4-1.6-2.9-1.6-1.2-.1-2.4.7-3 .7s-1.6-.7-2.6-.7c-1.3 0-2.6.8-3.3 2-1.4 2.4-.4 6 1 8 .7 1 1.5 2.1 2.5 2 1 0 1.4-.6 2.6-.6s1.5.6 2.6.6 1.7-1 2.4-2c.7-1.1 1-2.2 1-2.3-.1 0-2-.8-2-3.1z" />
          <path d="M14.4 6.2c.5-.7.9-1.6.8-2.5-.8 0-1.8.5-2.4 1.2-.5.6-1 1.6-.8 2.5.9.1 1.8-.5 2.4-1.2z" />
        </>,
        p
      );
    case 'android':
      return svg(
        <>
          <path d="M5 15V10a7 7 0 0 1 14 0v5z" />
          <path d="M4 15h16M8.5 6.5L7 4M15.5 6.5L17 4" />
          <circle cx="9.5" cy="10.5" r=".6" />
          <circle cx="14.5" cy="10.5" r=".6" />
          <path d="M6.5 15v3.5M17.5 15v3.5M10 15v4.5M14 15v4.5" />
        </>,
        p
      );
    case 'globe':
      return svg(
        <>
          <circle cx="12" cy="12" r="8.5" />
          <path d="M3.5 12h17M12 3.5c2.2 2.4 3.3 5.3 3.3 8.5S14.2 18.1 12 20.5c-2.2-2.4-3.3-5.3-3.3-8.5S9.8 5.9 12 3.5z" />
        </>,
        p
      );
    case 'qr':
      return svg(
        <>
          <rect x="4" y="4" width="6" height="6" rx="1" />
          <rect x="14" y="4" width="6" height="6" rx="1" />
          <rect x="4" y="14" width="6" height="6" rx="1" />
          <path d="M14 14h3v3h-3zM19 14h1M14 19h3M19 17v3" />
        </>,
        p
      );
    case 'chevron':
      return svg(<path d="M9 5l7 7-7 7" />, p);
    case 'search':
      return svg(
        <>
          <circle cx="10.5" cy="10.5" r="6.5" />
          <path d="m16 16 5 5" />
        </>,
        p
      );
    case 'profile':
      return svg(
        <>
          <circle cx="12" cy="8" r="3.5" />
          <path d="M5 20v-2a7 7 0 0 1 14 0v2" />
        </>,
        p
      );
    case 'bookmark':
      return svg(<path d="M6 4h12v17l-6-4-6 4z" />, p);
    case 'send':
      return svg(
        <>
          <path d="m3 10 18-7-6 18-4-7-8-4z" />
          <path d="m11 14 10-11" />
        </>,
        p
      );
    case 'check':
      return svg(<path d="M5 12.5l4.5 4.5L19 7" />, p);
    case 'plus':
      return svg(<path d="M12 5v14M5 12h14" />, p);
    case 'share':
      return svg(
        <>
          <path d="M12 3v13M8 7l4-4 4 4" />
          <path d="M5 14v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5" />
        </>,
        p
      );
    case 'spinner':
      return svg(<path d="M12 4a8 8 0 0 1 8 8" />, {
        ...p,
        className: `${p.className} ic--spin`,
      });
    case 'feed':
      return svg(
        <>
          <rect x="4" y="4" width="16" height="16" rx="4" />
          <path d="M7 10h10M7 14h6" />
        </>,
        p
      );
    case 'people':
      return svg(
        <>
          <path d="M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11z" />
          <circle cx="12" cy="10" r="2.5" />
        </>,
        p
      );
    case 'dating':
      return svg(
        <path d="M12 20s-7-4.4-7-9a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 4.6-7 9-7 9z" />,
        p
      );
    case 'events':
      return svg(
        <>
          <rect x="4" y="5" width="16" height="15" rx="3" />
          <path d="M4 10h16M9 3v4M15 3v4" />
        </>,
        p
      );
    case 'shop':
      return svg(
        <>
          <path d="M5 8h14l-1 12H6z" />
          <path d="M9 8V6a3 3 0 0 1 6 0v2" />
        </>,
        p
      );
    case 'services':
      return svg(
        <>
          <path d="M14.5 6.5a3.5 3.5 0 0 0 4.6 4.6L21 13l-8 8-2-2 1.9-1.9a3.5 3.5 0 0 0-4.6-4.6L6 10l5-5z" />
        </>,
        p
      );
    case 'space':
      return svg(
        <>
          <circle cx="12" cy="12" r="8.5" />
          <circle cx="12" cy="12" r="3.2" />
        </>,
        p
      );
    case 'star':
      return svg(
        <path d="M12 4l2.3 5.2 5.7.6-4.3 3.9 1.2 5.6L12 16.4 7.1 19.3l1.2-5.6L4 9.8l5.7-.6z" />,
        p
      );
    case 'wave':
      return svg(
        <>
          <path d="M3 10c2-2.6 4-2.6 6 0s4 2.6 6 0 4-2.6 6 0" />
          <path d="M3 16c2-2.6 4-2.6 6 0s4 2.6 6 0 4-2.6 6 0" />
        </>,
        p
      );
    case 'grid':
      return svg(
        <>
          <rect x="4" y="4" width="7" height="7" rx="2" />
          <rect x="13" y="4" width="7" height="7" rx="2" />
          <rect x="4" y="13" width="7" height="7" rx="2" />
          <rect x="13" y="13" width="7" height="7" rx="2" />
        </>,
        p
      );
    case 'chat':
      return svg(
        <path d="M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9l-5 4z" />,
        p
      );
    case 'heart':
      return svg(
        <path d="M12 20s-7-4.4-7-9a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 4.6-7 9-7 9z" />,
        p
      );
    case 'support':
      return svg(
        <>
          <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
          <rect x="2.6" y="13.5" width="4" height="6" rx="2" />
          <rect x="17.4" y="13.5" width="4" height="6" rx="2" />
        </>,
        p
      );
    case 'refresh':
      return svg(
        <>
          <path d="M20 12a8 8 0 1 1-2.4-5.7" />
          <path d="M20 4v5h-5" />
        </>,
        p
      );
    case 'lock':
      return svg(
        <>
          <rect x="5" y="10" width="14" height="10" rx="3" />
          <path d="M8.5 10V7.5a3.5 3.5 0 0 1 7 0V10" />
        </>,
        p
      );
    case 'shield':
      return svg(
        <>
          <path d="M12 3l7 3v6c0 4.2-2.9 7.6-7 9-4.1-1.4-7-4.8-7-9V6z" />
          <path d="M9 12l2 2 4-4" />
        </>,
        p
      );
    case 'map':
      return svg(
        <>
          <path d="M9 4L3.5 6.5v13L9 17l6 2.5 5.5-2.5v-13L15 6.5z" />
          <path d="M9 4v13M15 6.5v13" />
        </>,
        p
      );
    case 'live':
      return svg(
        <>
          <circle cx="12" cy="12" r="2.6" />
          <path d="M7.8 7.8a6 6 0 0 0 0 8.4M16.2 16.2a6 6 0 0 0 0-8.4" />
          <path d="M5 5a10 10 0 0 0 0 14M19 19a10 10 0 0 0 0-14" />
        </>,
        p
      );
    case 'wallet':
      return svg(
        <>
          <rect x="3.5" y="6" width="17" height="12.5" rx="3" />
          <path d="M3.5 10h17" />
          <circle cx="16.5" cy="14.2" r="1.1" />
        </>,
        p
      );
    default:
      return svg(<circle cx="12" cy="12" r="8" />, p);
  }
}
